<template>
  <div class="project-account-info">
    <div class="app-title mb" v-if="accountId">编辑账号</div>
    <div class="app-title mb" v-else>新增账号</div>
    <el-form class="max-width" ref="form" :model="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="用户账号" prop="phone" v-if="!this.accountId">
        <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="用户账号" v-if="this.accountId">
        <p>{{form.phone}}</p>
      </el-form-item>
      <el-form-item label="用户名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="用户职位" prop="title">
        <el-input v-model="form.title" placeholder="请输入职位"></el-input>
      </el-form-item>
      <el-form-item label="用户权限" prop="auth">
        <el-table ref="table" :data="authOptions" @selection-change="handleSelectionChange">
          <el-table-column label="管理权限" prop="permission_name"></el-table-column>
          <el-table-column type="selection"></el-table-column>
        </el-table>
      </el-form-item>
      <!-- <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启动</el-radio>
          <el-radio :label="2">关闭</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import regex from '@/assets/utils/regex.js';
  import ProjectService from '@/io/project.js';
  
  export default {
    name: 'ProjectAccountInfo',
    props: {
      accountId: {
        type: Number,
        default: null
      },
    },
    watch: {
      accountId: {
        handler(newValue, oldValue) {
          this.initAuthOptions().then(() => {
            if (newValue) {
              this.initDatas();
            }
          }).catch(() => {})
        },
        immediate: true
      }
    },
    data() {
      let self = this;
      return {
        checkPhone: this.debounce((value, callback) => {
          if (!regex.phone.rule.test(value)) {
            callback(new Error(regex.phone.text));
          } else {
            ProjectService.accountPhoneIsExist(self.id, value).then(res => {
              if (res.status) {
                callback(new Error('手机号已注册'));
              } else {
                callback();
              }
            }).catch(() => {});                  
          }
        }, 1000),
        id: this.$route.params.id,
        form: {
          phone: '',
          name: '',
          title: '',
          auth: [],
          status: 1
        },
        rules: {
          phone: [
            {
              required: true, message: '请输入手机号'
            },
            {
              validator(rule, value, callback) {
                self.checkPhone(value, callback);
              }
            }
          ],
          auth: [
            {
              required: true, message: '请选择用户权限'
            }
          ],
          status: [
            {
              required: true, message: '请选择状态'
            }
          ],
        },
        authOptions: []
      }
    },
    methods: {
      handleSelectionChange(val) {
        this.form.auth = val.map(val => {
          return val.permission_id;
        });
      },
      initDatas() {
        ProjectService.accountInfo(this.id, this.accountId).then(res => {
          this.form.phone = res.data.account_attr_data.account_attr_phone;
          this.form.name = res.data.account_attr_data.account_attr_name;
          this.form.title = res.data.account_attr_data.account_attr_title;
          this.authOptions.forEach((value, index) => {
            if (res.data.account_permission_data.map(val => val.permission_id).indexOf(value.permission_id) > -1) {
              this.$refs.table.toggleRowSelection(value);
            }
          });
          this.form.status = res.data.account_status;
        }).catch(() => {});
      },
      initAuthOptions() {
        return ProjectService.accountMenuList().then(res => {
          this.authOptions = res.data;
        }).catch(() => {});
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.accountId) {
              ProjectService.editAccount(
                this.id,
                this.accountId,
                this.form.phone,
                this.form.name,
                this.form.title,
                this.form.auth,
                this.form.status
              ).then(() => {
                this.$message.success('编辑成功');
                this.$emit('cancel');
                this.$emit('submit');
              }).catch(err => {
                // 我本不想在这里写 目前整体还没有合适的规划
                if (err.data.code === 200102) {
                  this.$message.error('请先联系管理员加入企业微信');
                }
              });
            } else {
              ProjectService.addAccount(
                this.id,
                this.form.phone,
                this.form.name,
                this.form.title,
                this.form.auth,
                this.form.status
              ).then(() => {
                this.$message.success('创建成功');
                this.$emit('cancel');
                this.$emit('submit');
              }).catch(err => {
                // 我本不想在这里写 目前整体还没有合适的规划
                if (err.data.code === 200102) {
                  this.$message.error('请先联系管理员加入企业微信');
                }
              });
            }
          }
        });
      },
      cancel() {
        this.$emit('cancel');
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .project-account-info {
    /deep/ .el-table {
      border: 1px solid @color-border-1;
      border-radius: 4px;
      &::before {
        display: none;
      }
      .el-table__header-wrapper {
        .el-table__header {
          thead {
            tr {
              th {
                background-color: @color-3;
              }
            }
          }
        }
      }
      th,
      td {
        border: none;
      }
    }
  }
</style>